import axios from "axios"
import config from "../config"

const services = {
    getSubscription : () => axios.get(`${config.apiUrl}/subscriptions`),
    getAssets : () => axios.get(`${config.apiUrl}/assets`),
    postEmail : (payload) => axios.post(`${config.apiUrl}/email`, payload),
    sendEmailToAssetId : (assetId, payload) => axios.post(`${config.apiUrl}/email/sendtoasset/${assetId}`, payload),
    sendEmailToITSupport : (payload) => axios.post(`${config.apiUrl}/email/sendtoitsupport`, payload),
}

export default services